import { faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Button from "../button/Button";
import Header from "../layout/header/Header";
import HeaderContainer from "../layout/header/HeaderContainers/HeaderContainer";
import FilterDropdown from "./dropdown/FilterDropdown";
import { emptyAllFitlers, hasAnyActiveFilter, IFilters } from "./utils/filteringUtils";

import "./Filters.scss";

interface IProps {
    filters: IFilters;
    onFiltersChange: (filters: IFilters) => void;
    maxHeight?: number;
}

export default function Filters(props: IProps) {
    const { t } = useTranslation();

    const atLeastOneFilterApplied = hasAnyActiveFilter(props.filters);

    return (
        <Header>
            <HeaderContainer>
                {Object.keys(props.filters).map((key, index) => {
                    if (key === "searchString" || key === "applyFilters") return null;

                    return (
                        <FilterDropdown
                            key={index}
                            filters={props.filters[key]}
                            label={key}
                            onFiltersChange={(filters) => {
                                props.onFiltersChange({
                                    ...props.filters,
                                    [key]: filters,
                                });
                            }}
                            maxHeight={props.maxHeight}
                        />
                    );
                })}
            </HeaderContainer>
            {atLeastOneFilterApplied && (
                <HeaderContainer>
                    <Button
                        variant="ghost"
                        onClick={() => {
                            props.onFiltersChange(emptyAllFitlers(props.filters)); // Reset filters
                        }}
                    >
                        <FontAwesomeIcon icon={faMultiply} />
                        {t("Filters.clear-all")}
                    </Button>
                </HeaderContainer>
            )}
        </Header>
    );
}
